import type { Appearance } from '@stripe/stripe-js';

// Direto da paleta, como em `stripe-connect/appearance.ts`.
// eslint-disable-next-line @typescript-eslint/no-require-imports
const { semantic, darkScales } = require('@/constants/palette') as {
  semantic: { dark: { background: string; foreground: string; card: string; border: string } };
  darkScales: Record<string, Record<string, string>>;
};

/**
 * Aparência dos Stripe Elements (cartão, Pix, boleto). No escuro usa o tema
 * `night` com os tons do app — com `stripe` fixo os rótulos saíam pretos
 * sobre o fundo escuro da página.
 */
export function elementsAppearance(scheme: 'light' | 'dark'): Appearance {
  const base = { colorPrimary: '#FD5001', borderRadius: '8px' };
  if (scheme !== 'dark') return { theme: 'stripe', variables: base };
  return {
    theme: 'night',
    variables: {
      ...base,
      colorBackground: semantic.dark.card,
      colorText: semantic.dark.foreground,
      colorTextSecondary: darkScales.neutral['500'],
      colorDanger: darkScales.error['600'],
    },
  };
}
